import { TaskStatus } from 'src/facade/tasks/tasksService.types'

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
	[TaskStatus.InProgress]: 'In progress',
	[TaskStatus.Finished]: 'Finished',
	[TaskStatus.Pending]: 'Pending',
	[TaskStatus.AwaitingAcceptance]: 'Awaiting acceptance',
}
